import { useState } from 'react'
import { describeTrack, type DescribeData } from '../../../api/music'
import { showToast } from '../../../components/Toast'
import { describingStore } from './describingStore'

/**
 * Анализ трека (Mureka /song/describe) — общий state + запуск для всех surface'ов
 * (кабинет трека + поповер действий), чтобы не дублировать (DRY). Результат
 * рисует DescribeModal.
 */
export function useDescribe() {
	const [describeData, setDescribeData] = useState<DescribeData | null>(null)
	const [describeBusy, setDescribeBusy] = useState(false)
	const runDescribe = async (trackId: string) => {
		if (describeBusy) return
		setDescribeBusy(true)
		describingStore.start(trackId)  // лоадинг-пилюля на треке в списке (per-track)
		try {
			const res = await describeTrack(trackId)
			if (res.ok && res.describe_data) setDescribeData(res.describe_data)
			else showToast(res.error || 'Не удалось проанализировать трек', 'error')
		} catch {
			showToast('Не удалось проанализировать трек', 'error')
		} finally {
			setDescribeBusy(false)
			describingStore.end(trackId)
		}
	}
	return { describeData, describeBusy, runDescribe, closeDescribe: () => setDescribeData(null) }
}
